export default __webpack_public_path__ + "static/media/windows_logo.412d2b4e.png";